export default "__VITE_ASSET__COyGHYqK__"